export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <span className="footer-copy muted">
          © {year} Ban Appeals
        </span>
        <nav className="footer-links">
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
          <a href="/invite" target="_blank" rel="noopener noreferrer">Invite the Bot</a>
          <a href="/support" target="_blank" rel="noopener noreferrer">Support Server</a>
        </nav>
      </div>
    </footer>
  );
}
